/**
 * @todo: We should probably change this to EUndefinedBool
 */
export enum EEnabled {
  E_Enabled,
  E_Disabled,
  E_Unknown,
}
